"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _Header = _interopRequireDefault(require("../header/Header"));

var _Footer = _interopRequireDefault(require("../footer/Footer"));

var _Sidenav = _interopRequireDefault(require("../sidenav/Sidenav"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _variables = require("../common/variables.js");

var _Icons = require("./Icons");

var _SidenavContext = require("./SidenavContext");

var _useTranslatedLabels = _interopRequireDefault(require("../useTranslatedLabels"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var year = new Date().getFullYear();

var Main = function Main(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, children);
};

var defaultHeader = function defaultHeader() {
  return /*#__PURE__*/_react["default"].createElement(_Header["default"], {
    underlined: true
  });
};

var defaultFooter = function defaultFooter() {
  return /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    copyright: "\xA9 DXC Technology ".concat(year, "\u200B\u200B\u200B\u200B. All rights reserved."),
    bottomLinks: [{
      href: "https://www.linkedin.com/company/dxctechnology",
      text: "Linkedin"
    }, {
      href: "https://twitter.com/dxctechnology",
      text: "Twitter"
    }, {
      href: "https://www.facebook.com/DXCTechnology/",
      text: "Facebook"
    }],
    socialLinks: [{
      href: "https://www.linkedin.com/company/dxctechnology",
      logo: _Icons.linkedinLogo
    }, {
      href: "https://twitter.com/dxctechnology",
      logo: _Icons.twitterLogo
    }, {
      href: "https://www.facebook.com/DXCTechnology/",
      logo: _Icons.facebookLogo
    }]
  });
};

var childTypeExists = function childTypeExists(children, childType) {
  return children.find(function (child) {
    return (child === null || child === void 0 ? void 0 : child.type) === childType;
  });
};

var DxcApplicationLayout = function DxcApplicationLayout(_ref2) {
  var _ref2$visibilityToggl = _ref2.visibilityToggleLabel,
      visibilityToggleLabel = _ref2$visibilityToggl === void 0 ? "" : _ref2$visibilityToggl,
      header = _ref2.header,
      sidenav = _ref2.sidenav,
      footer = _ref2.footer,
      children = _ref2.children;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isSidenavVisibleResponsive = _useState2[0],
      setIsSidenavVisibleResponsive = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      isResponsive = _useState4[0],
      setIsResponsive = _useState4[1];

  var ref = (0, _react.useRef)(null);
  var translatedLabels = (0, _useTranslatedLabels["default"])();

  var childrenArray = _react["default"].Children.toArray(children);

  var headerContent = header || defaultHeader();
  var footerContent = footer || defaultFooter();
  var main = childTypeExists(childrenArray, Main);

  var handleResize = function handleResize() {
    setIsResponsive(window.matchMedia("(max-width: ".concat(_variables.responsiveSizes.medium, "rem)")).matches);
  };

  var handleSidenavVisibility = function handleSidenavVisibility() {
    setIsSidenavVisibleResponsive(function (isSidenavVisibleResponsive) {
      return !isSidenavVisibleResponsive;
    });
  };

  (0, _react.useLayoutEffect)(function () {
    handleResize();
    window.addEventListener("resize", handleResize);
    return function () {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  (0, _react.useEffect)(function () {
    !isResponsive && setIsSidenavVisibleResponsive(false);
  }, [isResponsive]);
  return /*#__PURE__*/_react["default"].createElement(ApplicationLayoutContainer, {
    hasSidenav: sidenav ? true : false,
    isSidenavVisible: isSidenavVisibleResponsive,
    ref: ref
  }, /*#__PURE__*/_react["default"].createElement(HeaderContainer, null, headerContent), sidenav && isResponsive && /*#__PURE__*/_react["default"].createElement(VisibilityToggle, null, /*#__PURE__*/_react["default"].createElement(HamburgerTrigger, {
    onClick: handleSidenavVisibility,
    "aria-label": visibilityToggleLabel ? undefined : translatedLabels.applicationLayout.visibilityToggleTitle,
    title: translatedLabels.applicationLayout.visibilityToggleTitle
  }, _Icons.hamburgerIcon, visibilityToggleLabel)), /*#__PURE__*/_react["default"].createElement(BodyContainer, null, /*#__PURE__*/_react["default"].createElement(_SidenavContext.SidenavContextProvider, {
    value: setIsSidenavVisibleResponsive
  }, sidenav && (isResponsive ? isSidenavVisibleResponsive : true) && /*#__PURE__*/_react["default"].createElement(SidenavContainer, null, sidenav)), /*#__PURE__*/_react["default"].createElement(MainContainer, null, /*#__PURE__*/_react["default"].createElement(MainContentContainer, null, main), footerContent)));
};

var ApplicationLayoutContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  position: absolute;\n  top: 64px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n\n  @media (max-width: ", "rem) {\n    ", ";\n    ", "\n  }\n"])), _variables.responsiveSizes.medium, function (props) {
  return props.hasSidenav && "top: 116px";
}, function (props) {
  return props.isSidenavVisible && "overflow: hidden;";
});

var HeaderContainer = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 3;\n"])));

var VisibilityToggle = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  position: fixed;\n  top: 64px;\n  left: 0;\n  right: 0;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  padding: 4px 16px;\n  width: 100%;\n  background-color: #f2f2f2;\n  user-select: none;\n  z-index: 2;\n"])));

var HamburgerTrigger = _styledComponents["default"].button(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  border: 0px solid transparent;\n  border-radius: 2px;\n  padding: 12px 4px;\n  background-color: transparent;\n  box-shadow: 0 0 0 2px transparent;\n  font-family: Open Sans, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  color: #000;\n  cursor: pointer;\n  :active {\n    background-color: #cccccc;\n  }\n  :focus,\n  :focus-visible {\n    outline: none;\n    box-shadow: 0 0 0 2px #0095ff;\n  }\n  & > svg {\n    height: 20px;\n    width: 20px;\n  }\n"])));

var BodyContainer = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: row;\n  flex: 1;\n"])));

var SidenavContainer = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = (0, _taggedTemplateLiteral2["default"])(["\n  position: sticky;\n  top: 64px;\n  display: flex;\n  height: calc(100vh - 64px);\n  z-index: 1;\n\n  @media (max-width: ", "rem) {\n    position: absolute;\n    top: 0px;\n    height: 100%;\n  }\n"])), _variables.responsiveSizes.medium);

var MainContainer = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = (0, _taggedTemplateLiteral2["default"])(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));

var MainContentContainer = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = (0, _taggedTemplateLiteral2["default"])(["\n  flex: 1;\n"])));

DxcApplicationLayout.Header = _Header["default"];
DxcApplicationLayout.Main = Main;
DxcApplicationLayout.Footer = _Footer["default"];
DxcApplicationLayout.SideNav = _Sidenav["default"];
DxcApplicationLayout.useResponsiveSidenavVisibility = _SidenavContext.useResponsiveSidenavVisibility;
var _default = DxcApplicationLayout;
exports["default"] = _default;